import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import styles from "./energy-management.module.scss";
import CustomerPageLayout from "../customer-page-layout/CustomerPageLayout";
// import { ConsumptionSummaryCard, ConsumptionGraph, AnalyticsCarouselWrapper } from "./component";
import { CardFrameWithTabs } from "../../../common/components/card-frame-with-tabs/CardFrameWithTabs";
import { ConsumptionChartCard } from "./component/consumption-chart-card/ConsumptionChartCard";
import { ConsumptionCompareContent } from "./component/consumption-compare-content/consumptionCompareContent";
import { PostpaidBillHistoryCard } from "./component/postpaid-bill-history-card/PostpaidBillHistoryCard";
import { PrepaidLastPurchaseCard } from "./component/prepaid-last-purchase-card/PrepaidLastPurchaseCard";
import { UnitThresholdReminderRow } from "./component/unit-threshold-reminder-row/UnitThresholdReminderRow";
import { ComparationType } from "./enums/comparison-type";
import { ConsumerType } from "../../../model/energy-profile";
import { RootState } from "../../../stores/store";
import { FeatureFlagName } from "../../../tenant/features/featureFlags";
import { useFeatureFlag } from "../../../tenant/features/useFeatureFlag";
import { trackEnergyManagementOpened } from "../../../services/business-analytics/energyManagementEvents";
// import useWindowDimensions, { CurrentScreen } from "../../../hooks/use-window-dimensions";

export const EnergyManagement = () => {
	// const currentScreen: CurrentScreen = useWindowDimensions();
	const consumerType = useSelector((state: RootState) => state.customerEnergyProfile.consumerType);
	const isUnitThresholdReminderEnabled = useFeatureFlag(FeatureFlagName.UNIT_TRESHOLD_REMINDER);
	// Postpaid profiles carry an account number instead of a meter number.
	const meterId = useSelector((state: RootState) => state.customerEnergyProfile.meterNumber || state.customerEnergyProfile.accountNumber);
	// Guards against StrictMode's double effect run, so one visit is one event.
	const trackedOpen = useRef(false);

	useEffect(() => {
		if (trackedOpen.current) return;
		trackedOpen.current = true;
		trackEnergyManagementOpened(meterId);
	}, [meterId]);

	return (
		<CustomerPageLayout title="Energy management">
			<div className={styles.pageContent}>
				{isUnitThresholdReminderEnabled && <UnitThresholdReminderRow />}
				<ConsumptionChartCard />
				{consumerType === ConsumerType.Prepaid && <PrepaidLastPurchaseCard />}
				{consumerType === ConsumerType.Postpaid && <PostpaidBillHistoryCard/>}
				<CardFrameWithTabs
				tabs={[
					{ title: "DoD", content: <ConsumptionCompareContent comparationType={ComparationType.DoD} /> },
					{ title: "WoW", content: <ConsumptionCompareContent comparationType={ComparationType.WoW} /> },
					{ title: "MoM", content: <ConsumptionCompareContent comparationType={ComparationType.MoM} /> },
					{ title: "YoY", content: <ConsumptionCompareContent comparationType={ComparationType.YoY} /> },
				]}
			/>
			</div>
			{/* <div className={styles.graphsContainer}>
				<div className={styles.topContainer}>
					<ConsumptionSummaryCard />
					{!currentScreen.isMobile && <ConsumptionGraph />}
				</div>
				<AnalyticsCarouselWrapper />
				<CardFrameWithTabs tabs={[
					{ title: "DoD", content: <ConsumptionCompareContent comparationType={ComparationType.DoD} /> },
					{ title: "WoW", content: <ConsumptionCompareContent comparationType={ComparationType.WoW} /> },
					{ title: "MoM", content: <ConsumptionCompareContent comparationType={ComparationType.MoM} /> },
					{ title: "YoY", content: <ConsumptionCompareContent comparationType={ComparationType.YoY} /> },
				]} />
				{currentScreen.isMobile && (
					<div style={{ marginTop:0}}>
						<ConsumptionGraph />
					</div>
				)}
			</div> */}
		</CustomerPageLayout>
	);
};
